import { render, staticRenderFns } from "./segmented-bar.component.vue?vue&type=template&id=effb88c4&scoped=true"
import script from "./segmented-bar.component.vue?vue&type=script&lang=ts"
export * from "./segmented-bar.component.vue?vue&type=script&lang=ts"
import style0 from "./segmented-bar.component.vue?vue&type=style&index=0&id=effb88c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effb88c4",
  null
  
)

export default component.exports